import { render, staticRenderFns } from "./NsConfirm.vue?vue&type=template&id=6f36661d&scoped=true&"
import script from "./NsConfirm.vue?vue&type=script&lang=js&"
export * from "./NsConfirm.vue?vue&type=script&lang=js&"
import style0 from "./NsConfirm.vue?vue&type=style&index=0&id=6f36661d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f36661d",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {NsButton: require('/usr/app/src/components/ns/NsButton.vue').default})
